
import { defineComponent } from 'vue';
import { GlobalAlert } from '~/plugins/alerts/types';
import { getGlobalAlerts, removeGlobalAlert } from '~/plugins/alerts/state';
import Alert from './GlobalAlert.vue';

export default defineComponent({
  name: 'GlobalAlerts',

  components: { Alert },

  computed: {
    alerts(): Array<GlobalAlert> {
      return getGlobalAlerts();
    },
  },

  methods: {
    remove(id: number) {
      removeGlobalAlert(id);
    },
  },
});
